import React, { FC } from "react"
import { HR, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { Button } from "components/views/atoms/buttons/Button"
import L10n from "lib/carrot-l10n"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ModalErrorStep: FC = () => {
  return (
    <div className="tc pa5">
      <H2>{l`An unknown error occurred.`}</H2>
      <Spacer height={0.25} />
      <Body color="black-80">{l`Please refresh the page and try again.`}</Body>
      <Spacer height={1.5} />
      <HR color="pampas" width={2} />
      <Spacer height={1.5} />
      <div className="flex flex-row">
        <ButtonPrimary onClick={() => window.location.reload()}>{l`Refresh the page`}</ButtonPrimary>
        <Spacer width={1} />
        <Button to="/" outline>
          {l`Carrot Home`}
        </Button>
      </div>
    </div>
  )
}

export { ModalErrorStep }
